/**
 * Asynchronously loads the component for CourseBuilderContainer
 */
import Loadable from 'react-loadable';
import Spinner from 'components/FullScreenSpinner';

export default Loadable({
  loader: () => import(/* webpackChunkName: "CourseBuilder" */ './index'),
  loading: Spinner,
});
